import { db } from 'services/firebase';
import {
  DRUG_REFERENCE_COLLECTIONS,
  DRUG_METADATA_DOCS,
  EMERGENCY_MEDICINE_SPECIALTY,
  QUEUE_STATUS,
} from '../constants/collections';

const { DRUGS, DRUG_METADATA, DRUG_UPDATE_QUEUE, DRUG_UPDATE_LOG, REFRESH_SCHEDULES } =
  DRUG_REFERENCE_COLLECTIONS;

export async function fetchDrugById(drugId) {
  if (!drugId) return null;
  const snap = await db.collection(DRUGS).doc(drugId).get();
  if (!snap.exists) return null;
  return { id: snap.id, ...snap.data() };
}

export async function searchDrugsBySpecialty(specialtyId = EMERGENCY_MEDICINE_SPECIALTY, limit = 200) {
  const snap = await db
    .collection(DRUGS)
    .where('specialties', 'array-contains', specialtyId)
    .limit(limit)
    .get();
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export function subscribePendingQueueItems(onChange, onError) {
  return db
    .collection(DRUG_UPDATE_QUEUE)
    .where('status', '==', QUEUE_STATUS.PENDING)
    .orderBy('createdAt', 'desc')
    .onSnapshot(
      (snap) => onChange(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
      onError
    );
}

export async function fetchSpecialtiesMetadata() {
  const snap = await db.collection(DRUG_METADATA).doc(DRUG_METADATA_DOCS.SPECIALTIES).get();
  return snap.exists ? snap.data() : null;
}

export async function fetchCuratedListsMetadata() {
  const snap = await db.collection(DRUG_METADATA).doc(DRUG_METADATA_DOCS.CURATED_LISTS).get();
  return snap.exists ? snap.data() : null;
}

export async function fetchRefreshSchedule(userId) {
  if (!userId) return null;
  const snap = await db.collection(REFRESH_SCHEDULES).doc(userId).get();
  return snap.exists ? snap.data() : null;
}

export async function fetchDrugUpdateLog(limit = 50) {
  const snap = await db
    .collection(DRUG_UPDATE_LOG)
    .orderBy('timestamp', 'desc')
    .limit(limit)
    .get();
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
